import { useCallback, useState } from 'react';

import { useChartSettingsState } from 'contexts/chart/chart-settings-context';

export const useChartLegendVisibility = () => {
  const { settings } = useChartSettingsState();
  const [override, setOverride] = useState<boolean | null>(null);

  const visible = override ?? settings.legendsEnabled;
  const toggle = useCallback(() => setOverride((current) => !(current ?? settings.legendsEnabled)), [settings.legendsEnabled]);

  return { visible, toggle };
};
